import { render } from "./arsip-list.vue?vue&type=template&id=6cbd1b32"
import script from "./arsip-list.vue?vue&type=script&lang=js"
export * from "./arsip-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__